import url_ from "asset-data:assets/galleries/featured/street_bd09cadfa7__400.jpg";
export const url = url_;